import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function AccountsDashboard() {
  const user = useSelector((state) => state.authState?.user);

  const todayTransactions = [
    { id: 1, time: '09:15 AM', type: 'Fee Collection', amount: '₹ 12,500' },
    { id: 2, time: '11:00 AM', type: 'Expense Entry', amount: '₹ 3,200' },
    { id: 3, time: '01:30 PM', type: 'Refund', amount: '₹ 1,500' },
  ];

  const notices = [
    'Verify pending fee receipts',
    'Monthly expense closing due tomorrow',
    'Export fee report before end of day',
  ];

  return (
    <div className='container-fluid py-4'>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <div>
          <h4 className='fw-bold text-dark mb-1'>
            Welcome,{' '}
            <span className='text-primary'>{user?.user_name || 'Accounts'}</span>
          </h4>
          <p className='text-muted m-0'>Here is your accounts dashboard</p>
        </div>

        <div>
          <span className='badge bg-light text-dark px-3 py-2 rounded-pill'>
            Accounts
          </span>
        </div>
      </div>

      <Row className='g-4 mb-4'>
        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-currency-rupee text-success'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Today Collection
                </h6>
                <h2 className='fw-bold mb-0'>₹ 45K</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-receipt-cutoff text-primary'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Pending Fees
                </h6>
                <h2 className='fw-bold mb-0'>18</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-wallet2 text-warning'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Expenses Today
                </h6>
                <h2 className='fw-bold mb-0'>₹ 9K</h2>
              </div>
            </div>
          </div>
        </Col>

        <Col sm='6' lg='3'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <div className='d-flex align-items-center justify-content-between'>
              <i
                className='bi bi-file-earmark-bar-graph-fill text-danger'
                style={{ fontSize: '3rem' }}
              ></i>
              <div className='text-end'>
                <h6 className='text-muted text-uppercase fw-semibold mb-1'>
                  Reports Pending
                </h6>
                <h2 className='fw-bold mb-0'>3</h2>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className='g-4'>
        <Col lg='8'>
          <div className='card border-0 shadow-sm rounded-4 p-4 h-100'>
            <h5 className='fw-bold mb-3'>
              <i className='bi bi-table text-primary me-2'></i>
              Today Transactions
            </h5>

            <div className='table-responsive'>
              <table className='table align-middle'>
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Type</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {todayTransactions.map((item) => (
                    <tr key={item.id}>
                      <td>{item.time}</td>
                      <td>{item.type}</td>
                      <td>{item.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>

        <Col lg='4'>
          <div className='card border-0 shadow-sm rounded-4 p-4 mb-4'>
            <h5 className='fw-bold mb-3'>Quick Links</h5>
            <div className='d-grid gap-2'>
              <Link
                to='/fees-collection'
                className='btn btn-outline-primary btn-sm'
              >
                Fees Collection
              </Link>
              <Link
                to='/expense-entry'
                className='btn btn-outline-success btn-sm'
              >
                Expense Entry
              </Link>
              <Link
                to='/fee-report'
                className='btn btn-outline-warning btn-sm'
              >
                Fee Reports
              </Link>
            </div>
          </div>

          <div className='card border-0 shadow-sm rounded-4 p-4'>
            <h5 className='fw-bold mb-3'>Notices</h5>
            <ul className='list-group list-group-flush small'>
              {notices.map((item, index) => (
                <li key={index} className='list-group-item px-0'>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
}